module.exports = __webpack_public_path__ + "static/media/errorpixie.af3e9ef5.png";